<template>
  <div class="container">
    <p>
      <button type="button" class="btn btn-primary btn-round" @click="goBack">
        <i class="fa fa-chevron-left" aria-hidden="true"></i>返回
      </button>
      <b-button v-b-modal.modal-form class="btn btn-danger btn-round"
        ><i class="fas fa-bug"></i>錯誤回報</b-button
      >
    </p>
    <div class="row">
      <div class="col-md-7">
        <img
          :src="content.imgFolder + content.imgName"
          class="img-fluid"
          :alt="content.subject"
        />
      </div>
      <div class="col-md-5">
        <p>
          <span class="badge badge-danger">{{ content.kindName }}</span>
        </p>
        <h3>{{ content.subject }}</h3>
        <ul class="list-unstyled list-content">
          <li>
            <i class="far fa-calendar"></i
            >{{ content.occurDate | datestringformat }}
          </li>
          <li><i class="fas fa-map-marker-alt"></i>{{ content.location }}</li>
          <li>
            <i class="fas fa-location-arrow"></i>經緯度:
            {{ content.longitude }}, {{ content.latitude }}
          </li>
          <li v-if="content.name">
            <i class="far fa-user"></i>提供者: {{ content.name }}
          </li>
        </ul>
        <p>
          {{ content.description }}
        </p>
      </div>
    </div>
    <hr class="mt-2 mb-5" />
    <div class="row text-center text-lg-left" data-ciao="lightbox-gallery">
      <div
        class="col-lg-3 col-md-4 col-6"
        v-for="(image, index) in content.images"
        :key="index"
        @click="() => showImg(index)"
      >
        <img
          class="img-fluid img-thumbnail"
          :src="image.fileLocation + image.fileName"
          :alt="content.subject + '相關照片'"
        />
      </div>
    </div>
    <b-modal
      id="modal-form"
      class="modal-dialog-centered"
      ref="modal"
      title="錯誤回報"
      cancel-title="取消"
      ok-title="送出回報資訊"
      footer-class="modal-footer"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <div class="form-group">
          <label for="name" class="col-form-label">稱呼:</label>
          <input
            type="text"
            class="form-control"
            id="name"
            name="name"
            v-model.trim="$v.report.name.$model"
            :class="{ 'is-invalid': $v.report.name.$error }"
            maxlength="50"
          />
          <div class="invalid-feedback" v-if="!$v.report.name.required">
            此欄位為必填
          </div>
        </div>
        <div class="form-group">
          <label for="email" class="col-form-label">Email:</label>
          <input
            type="text"
            class="form-control"
            id="email"
            name="email"
            v-model.trim="$v.report.email.$model"
            :class="{ 'is-invalid': $v.report.email.$error }"
            maxlength="50"
          />
          <div class="invalid-feedback" v-if="!$v.report.email.required">
            此欄位為必填
          </div>
          <div class="invalid-feedback" v-if="!$v.report.email.email">
            請輸入正確的電子郵件
          </div>
        </div>
        <div class="form-group">
          <label for="comment" class="col-form-label">錯誤資訊說明:</label>
          <textarea
            class="form-control"
            id="comment"
            name="comment"
            v-model.trim="$v.report.comment.$model"
            :class="{ 'is-invalid': $v.report.comment.$error }"
          ></textarea>
          <div class="invalid-feedback" v-if="!$v.report.comment.required">
            此欄位為必填
          </div>
        </div>
      </form>
    </b-modal>
    <vue-easy-lightbox
      :visible="visible"
      :imgs="imgs"
      :index="index"
      @hide="handleHide"
    ></vue-easy-lightbox>
  </div>
</template>

<script>
import { apiContent, apiReport } from '@/api/index'
import { required, email } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      content: {},
      imgs: [],
      visible: false,
      index: 0,
      report: {
        parent: this.$route.params.code,
        name: '',
        email: '',
        comment: '',
      },
    }
  },
  validations: {
    report: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      comment: {
        required,
      },
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    showImg(index) {
      this.index = index
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
    resetModal() {
      this.report.name = ''
      this.report.email = ''
      this.report.comment = ''
      this.nameState = null
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleSubmit()
    },
    handleSubmit() {
      this.submitStatus = 'PENDING'
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
        return
      } else {
        this.Send()
      }
    },

    async Send() {
      let loader = this.$loading.show()
      await apiReport(this.report)
        .then(response => {
          this.submitStatus = null
          setTimeout(() => {
            loader.hide()
            this.$bvModal.hide('modal-form')
            this.$swal('錯誤回報完成。')
          }, 800)
        })
        .catch(err => {
          this.submitStatus = null
          setTimeout(() => {
            loader.hide()
            this.$swal('', '回報傳送失敗，請稍後嘗試。', 'error')
          }, 800)
        })
    },
    async getContent() {
      let loader = this.$loading.show()
      await apiContent(this.$route.params.code)
        .catch(error => {
          if (error.response) {
            this.goBack()
          }
        })
        .then(response => {
          if (response) {
            this.content = response.data
            for (let i = 0; i < this.content.images.length; i++) {
              this.imgs.push(
                this.content.images[i].fileLocation +
                  this.content.images[i].fileName
              )
            }
          }
          setTimeout(() => {
            loader.hide()
          }, 800)
        })
    },
    NotFound() {
      this.$router.push('./')
    },
  },
  mounted() {
    window.scrollTo(0, 0)
    this.getContent()
  },
}
</script>
